import React from "react";
import { Tooltip } from 'antd';
import {
  ExchangeToTable,
  FooterWrapper,
  DollarAmount,
  PoolName,
  ResetAll,
  UnderlyingContent,
  PoolDataValue,
  PoolDataHeading
} from "./styles";
import formatter from "../../../../../utils/formatter";
import caret_top from "../../../../../assets/icons/caret-t.svg";
import caret_bottom from "../../../../../assets/icons/caret-b.svg";
import PercentageInput from "../../../../../CommonComponents/PercentageInput/PercentageInput";
import { milliToDate } from '../../../../../utils/commonUtil';
import { replaceSelect } from '../../../../../utils/replacer';

const TiffFormTable = props => {
  const columns = [
    {
      title: () => {
        return <PoolDataValue>Investment options</PoolDataValue>;
      },
      render: (text, row, index) => {
        if (index === 0) {
          return {
            children: row.investmentType.toLowerCase(),
            props: {
              colSpan: 5
            }
          };
        }
        return {
          props: {
            colSpan: 0
          }
        };
      },
      key: "poolName",
      width: "20%"
    },
    {
      title: () => {
        return <PoolDataValue>Investment options</PoolDataValue>;
      },
      render: record => {
        if (record.poolName !== undefined) {
          return (
            <PoolName
              onClick={() =>
                props.onPoolNameClicked(record.poolName)
              }
            >
              {replaceSelect(record.poolName)}
            </PoolName>
          );
        }
      },
      key: "poolName",
      width: "25%"
    },
    {
      title: () => {
        return <PoolDataValue>Available balance</PoolDataValue>;
      },
      dataIndex: "availableBalance",
      key: "availableBalance",
      width: "20%",
      render: text => (
        text !== 0 ? <PoolDataHeading>
          {formatter({ value: text, fieldSuffix: "Dollars" })}
        </PoolDataHeading> : <>&mdash;</>
      )
    },
    {
      title: () => {
        return <PoolDataValue>Available units</PoolDataValue>;
      },
      dataIndex: "availableUnits",
      key: "availableUnits",
      width: "20%",
      render: text => (
        text !== 0 ? <PoolDataHeading>
          {formatter({ value: text, fieldSuffix: "Units" })}
        </PoolDataHeading> : <>&mdash;</>
      )
    },
    {
      title: () => {
        return <PoolDataValue>Price per unit</PoolDataValue>;
      },
      render: (text, row) => {
        const perUpdatedOn = 'Price updated on ' + milliToDate(row.dateOfPricePerUnit);
        const perUpdatedAsOf = 'Price updated on ' + milliToDate(row.asOfDate);
        return (
          text !== null ?
            <Tooltip placement="bottomLeft" title={row.availableBalance ? perUpdatedOn : perUpdatedAsOf}>
              <UnderlyingContent>
                {formatter({ value: text, fieldSuffix: "Dollars" })}
                {row.isRise ? (
                  <img src={caret_top} alt="rise" className="mb-05 ml-05" />
                ) : (
                    <img src={caret_bottom} alt="fall" className="mb-05 ml-05" />
                  )}
              </UnderlyingContent>
            </Tooltip> : <>&mdash;</>
        );
      },
      dataIndex: "pricePerUnit",
      key: "pricePerUnit",
      width: "20%"
    },
    {
      title: () => {
        return <PoolDataValue className="right">Percentage</PoolDataValue>;
      },
      render: (text, record) => {
        if (!Object.prototype.hasOwnProperty.call(text, "investmentType")) {
          return (
            <span>
              <PercentageInput
                onChange={e => {
                  const { value } = e.target;
                  props.setInputValues({
                    key: record.poolId,
                    value
                  });
                  return true;
                }}
                value={props.inputValues[record.poolId]}
              />
            </span>
          );
        }
      },
      key: "Dollar",
      width: "15%"
    }
  ];

  function addTitleObj(filteredPools, poolCategory) {
    !!filteredPools.length &&
      filteredPools.unshift({ investmentType: poolCategory });
    return filteredPools;
  }

  function filterPools(investmentPools, poolCategory) {
    return addTitleObj(
      investmentPools.filter(
        pool => pool.poolCategory === poolCategory.toUpperCase()
      ),
      poolCategory
    );
  }

  function renderFooter() {
    return (
      <FooterWrapper>
        <PoolDataHeading className="left">Total</PoolDataHeading>
        <div className="right">
          <DollarAmount>{props.totalPercentage}%</DollarAmount>
          <PoolDataHeading>out of 100%</PoolDataHeading>
        </div>
        {props.totalPercentage !== 0 && <ResetAll className="right" onClick={props.clearAll}>Clear All</ResetAll>}
      </FooterWrapper>
    );
  }
  return [
    "PORTFOLIO SOLUTIONS",
    "PORTFOLIO BUILDERS",
    "VALUES DRIVEN INVESTMENTS"
  ].map(
    (poolCategory, index) =>
      !!filterPools(props.investmentPools, poolCategory).length && (
        <ExchangeToTable
          data-test="container"
          showHeader={index <= 0}
          pagination={false}
          style={{ width: "100%" }}
          columns={columns}
          dataSource={filterPools(props.investmentPools, poolCategory)}
          footer={index == 2 && renderFooter}
        />
      )
  );
};

export default TiffFormTable;
